var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3258 0.612923L0.876731 6.18598C-0.109444 6.58165 -0.103595 7.13169 0.696979 7.37696L4.30063 8.50174L5.67947 12.7292C5.8471 13.1918 5.76447 13.3754 6.25034 13.3754C6.6253 13.3754 6.79164 13.2044 7.00047 13.0004C7.13328 12.8704 7.92178 12.1038 8.80219 11.2478L12.5507 14.0174C13.2404 14.3979 13.7385 14.2008 13.9102 13.3768L16.3708 1.78153C16.6228 0.771535 15.9858 0.313406 15.3258 0.612923ZM4.86618 8.24332L12.9888 3.11869C13.3943 2.87277 13.7661 3.00498 13.4609 3.27596L6.50575 9.55123L6.23494 12.4396L4.86618 8.24332V8.24332Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/Skype.4849cdef105ab08f87abd256cfa8934a.svg";
export { ForwardRef as ReactComponent };